const cartRequestHeaders = {
  "Content-Type": "application/json",
};

const assertCartResponse = async (response, action) => {
  if (response.ok) return response;

  let errorMessage = response.statusText;

  try {
    const error = await response.json();
    errorMessage = error.message || error.description || errorMessage;
  } catch {
    // Keep the HTTP status text when Shopify returns a non-JSON error page.
  }

  throw new Error(`${action} failed: ${response.status} ${errorMessage}`);
};

const clearCartItems = async () =>
  assertCartResponse(
    await fetch("/cart/clear.js", {
      method: "POST",
      headers: cartRequestHeaders,
    }),
    "Clearing cart",
  );

class ClearCartBtn extends HTMLElement {
  constructor() {
    super();
    this.clearCart = this.clearCart.bind(this);
  }

  connectedCallback() {
    this.btn = this.querySelector("button");
    this.btn?.addEventListener("click", this.clearCart);
  }

  disconnectedCallback() {
    this.btn?.removeEventListener("click", this.clearCart);
  }

  async clearCart() {
    try {
      await clearCartItems();
      window.location.reload();
    } catch (error) {
      console.error("Error clearing cart:", error);
    }
  }
}

if (!customElements.get("clear-cart-btn")) {
  customElements.define("clear-cart-btn", ClearCartBtn);
}

const refreshCartOnLogin = async () => {
  const urlParams = new URLSearchParams(window.location.search);
  if (!urlParams.has("just-logged-in")) {
    return;
  }
  try {
    await clearCartItems();

    if (window.location.pathname !== "/pages/truckload-test") {
      window.location.href = "/";
    }
  } catch (error) {
    console.error("Error:", error);
  }
};

document.addEventListener("DOMContentLoaded", () => {
  refreshCartOnLogin();
});
